import React, { useEffect, useState } from 'react';
import { StatusBadge } from '../../components/admin/StatusBadge';

export const InquiryList: React.FC = () => {
  const [inquiries, setInquiries] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState<string | null>(null);

  useEffect(() => {
    fetch('/api/inquiries', { credentials: 'include' })
      .then(r => r.json())
      .then(data => { setInquiries(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-[#1A1A1A] tracking-tight">Inquiries</h1>
          <p className="text-sm text-[#A3A3A3] mt-1">{inquiries.length} total inquiries</p>
        </div>
      </div>

      {loading ? (
        <div className="space-y-3">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="h-20 bg-white rounded-2xl animate-pulse shadow-sm" />
          ))}
        </div>
      ) : (
        <div className="space-y-3">
          {inquiries.map(inq => (
            <div
              key={inq.id}
              className="bg-white border border-[#E8E6E2]/60 rounded-2xl overflow-hidden shadow-sm shadow-black/[0.03] hover:shadow-md hover:shadow-black/[0.05] transition-shadow"
            >
              <button
                onClick={() => setExpanded(expanded === inq.id ? null : inq.id)}
                className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-[#FAFAF8]/50 transition-colors"
              >
                <div className="flex items-center gap-4">
                  <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#F0EDE8] to-[#E8E6E2] flex items-center justify-center text-sm font-semibold text-[#6B6B6B]">
                    {inq.name?.charAt(0)?.toUpperCase() || '?'}
                  </div>
                  <div>
                    <p className="font-semibold text-[#1A1A1A] text-sm">{inq.name}</p>
                    <p className="text-xs text-[#A3A3A3]">{inq.email} {inq.company ? `· ${inq.company}` : ''}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-xs text-[#A3A3A3] tabular-nums">
                    {new Date(inq.createdAt).toLocaleDateString()}
                  </span>
                  <StatusBadge status={inq.status} />
                  <svg
                    width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                    className={`text-[#A3A3A3] transition-transform duration-200 ${expanded === inq.id ? 'rotate-180' : ''}`}
                  >
                    <path d="M4 6l4 4 4-4"/>
                  </svg>
                </div>
              </button>

              {expanded === inq.id && (
                <div className="px-6 pb-5 border-t border-[#E8E6E2]/60">
                  <div className="pt-4 pl-[52px] space-y-3">
                    <div>
                      <p className="text-[11px] text-[#A3A3A3] uppercase tracking-[0.12em] font-semibold mb-1">Subject</p>
                      <p className="text-sm text-[#1A1A1A] font-medium">{inq.subject}</p>
                    </div>
                    <div>
                      <p className="text-[11px] text-[#A3A3A3] uppercase tracking-[0.12em] font-semibold mb-1">Message</p>
                      <p className="text-sm text-[#6B6B6B] whitespace-pre-wrap leading-relaxed">{inq.message}</p>
                    </div>
                    {inq.coffeeName && (
                      <div>
                        <p className="text-[11px] text-[#A3A3A3] uppercase tracking-[0.12em] font-semibold mb-1">Related Coffee</p>
                        <p className="text-sm text-[#6B6B6B]">{inq.coffeeName}</p>
                      </div>
                    )}
                    <div className="pt-1">
                      <a
                        href={`mailto:${inq.email}?subject=Re: ${encodeURIComponent(inq.subject)}`}
                        className="inline-flex items-center gap-1.5 text-sm font-medium text-[#F05A1E] hover:text-[#D44A14] transition-colors"
                      >
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                          <rect x="1" y="3" width="12" height="8" rx="1"/><path d="M1 4l6 4 6-4"/>
                        </svg>
                        Reply via email
                      </a>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}

          {inquiries.length === 0 && (
            <div className="text-center py-16 text-[#A3A3A3]">No inquiries yet.</div>
          )}
        </div>
      )}
    </div>
  );
};
